module.exports = __webpack_public_path__ + "DataService_Banner.png?a59b0442433cac3061daed00cff6e9d6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ProductAndService/DataService/DataService_Banner.png
// module id = 160
// module chunks = 0